"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = tslib_1.__importDefault(require("immer"));
const getContentType_1 = require("../../helpers/getContentType");
const getProgressResetEvent_1 = require("../../helpers/getEvent/getProgressResetEvent");
const getState_1 = require("../../helpers/getState");
const isEmptyObject_1 = tslib_1.__importDefault(require("../../helpers/isEmptyObject"));
const entity_1 = require("../../type/entity");
const assignmentCardZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/assignmentCardZeroState"));
const assignmentQuestionZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/assignmentQuestionZeroState"));
const cardQuestionForReviewZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/cardQuestionForReviewZeroState"));
const checkpointZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/checkpointZeroState"));
const courseZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/courseZeroState"));
const iltZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/iltZeroState"));
const learningCardZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/learningCardZeroState"));
const pathZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/pathZeroState"));
const peerReviewCardZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/peerReviewCardZeroState"));
const sectionZeroState_1 = tslib_1.__importDefault(require("../../zeroStates/nodeZeroState/sectionZeroState"));
const addReplaceStateWithSameVersion_1 = tslib_1.__importDefault(require("./addReplaceStateWithSameVersion"));
function getZeroStateOfContent(content, user) {
    try {
        let state = {};
        const contentType = getContentType_1.getContentType(content);
        switch (contentType) {
            case entity_1.ContentType.LEARNING_CARD:
                state = learningCardZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.ASSIGNMENT_CARD:
                state = assignmentCardZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.CARD_QUESTION:
                state = assignmentQuestionZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.PEER_REVIEW_CARD:
                state = peerReviewCardZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.CARD_QUESTION_FOR_REVIEW:
                state = cardQuestionForReviewZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.SECTION:
                state = sectionZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.COURSE:
                state = courseZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.CURRICULUM:
                state = pathZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.CHECKPOINT:
                state = checkpointZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.ILT:
                state = iltZeroState_1.default(content, user);
                break;
            default:
                break;
        }
        return state;
    }
    catch (error) {
        throw new Error('Error in getZeroStateOfContent ' + error);
    }
}
function checkIsUpdatedState(states, content, user) {
    const { userId } = user;
    const stateIndex = getState_1.getIndexOfStateByContentIdUserId(states, content._id, userId);
    if (stateIndex > -1) {
        const state = states[stateIndex];
        const { updatedAt, createdAt, scaledProgressMeasure = 0, completionStatus, timeSpent, progressMeasure } = state;
        if (updatedAt === createdAt &&
            scaledProgressMeasure === 0 &&
            completionStatus === 'notAttempted' &&
            timeSpent === 0 &&
            progressMeasure === 0) {
            return false;
        }
    }
    return true;
}
function applyResetState(command, user, content, states, enrolments, stateInteractions) {
    let updatedStates = states;
    const newEvents = [];
    const { userId, companyId } = user;
    const { rootContentId, timeStamp } = command;
    if (content.children) {
        for (const childContent of content.children) {
            const childAssignPayload = applyResetState(command, user, childContent, updatedStates, enrolments, stateInteractions);
            updatedStates = childAssignPayload.states;
            newEvents.push(...childAssignPayload.events);
        }
    }
    updatedStates = immer_1.default(updatedStates, draftStates => {
        const isUpdatedState = checkIsUpdatedState(draftStates, content, user);
        if (isUpdatedState) {
            const newState = getZeroStateOfContent(content, user);
            if (!isEmptyObject_1.default(newState)) {
                newState.updatedAt = timeStamp;
            }
            addReplaceStateWithSameVersion_1.default(draftStates, newState);
        }
        if (content._id === command.rootContentId) {
            const contentType = getContentType_1.getContentType(content);
            const resetProgressEvent = getProgressResetEvent_1.getProgressResetEvent(command, companyId, userId, rootContentId, contentType);
            newEvents.push(resetProgressEvent);
        }
    });
    return {
        events: newEvents,
        states: updatedStates,
        stateInteractions,
        enrolments
    };
}
exports.applyResetState = applyResetState;
//# sourceMappingURL=applyResetState.js.map